var FilesManager = {
	text:"",
	nb_additional_files : $('.autre').length,

	init:function(){

		/*Debug.log("_____FILES MANAGER INIT_____");*/
		FilesManager.text = $(".files-manager .add-file .bt-text").html();
		FilesManager.create_newFile(FilesManager.text, false);

		$(".files-manager .add-file").on("click touchend", function(e){
			if(e.type == "touchend"){
				$(this).off("click");
			}
			FilesManager.create_newFile("Parcourir", true);
		});

		// OUVERTURE FORMULAIRE WHEN CLICK BT MODIFIER
		$(".btn-modifier").on("click touchend", function(e){
			if(e.type == "touchend"){
				$(this).off("click");
			}
			$(".account-container .btn-modifier").addClass("open");
			$(".account-container .modif-infos").addClass("open");	
		});


		// FERMETURE FORMULAIRE WHEN CLICK ANNULER
		$(".bt-annuler").on("click touchend", function(e){
			if(e.type == "touchend"){
				$(this).off("click");
			}
			$(".account-container .btn-modifier").removeClass("open");
			$(".account-container .modif-infos").removeClass("open");	

			//SCROLL BACK TO TOP
			$('html, body').animate( { scrollTop:0}, 800 );
		});
	},

	create_newFile: function(pTitle, pDynamic){
		/*Debug.log("CREATE NEW FILE UPLOAD");*/
		
		$(".add-file").addClass("hidden");
		
		FilesManager.nb_additional_files ++;
		var _newFile = '<div class="form-item autre-'+ FilesManager.nb_additional_files +'"><input type="file" name="file-autre-'+ FilesManager.nb_additional_files +'" id="file-autre-'+ FilesManager.nb_additional_files +'" class="inputfile" /><label class="file-autre-'+ FilesManager.nb_additional_files +'-name" for="file-autre-'+ FilesManager.nb_additional_files +'">' + pTitle + '</label><div class="bt-close"></div></div>';

		$(".form-items.files").append(_newFile);
		$('.autre-'+ FilesManager.nb_additional_files).css({opacity:0}).animate({opacity:1}, 1000);

		window['file-'+FilesManager.nb_additional_files] = new InputFileManager('autre-'+ FilesManager.nb_additional_files, pDynamic);

	}, 
	removeFile:function(pTarget){
		$("." + pTarget).remove();
	}
}

function InputFileManager(pTarget, dynamic){
	var _isDynamic = dynamic;
	var _name = pTarget;
	var _input = $("#file-" + pTarget);
	var _label = $('.file-'+pTarget+'-name');

	var noFile_text = _label.html();

	/*Debug.log("NEW INPUT FILE MANAGER : " + pTarget);*/

	_input.change(function() {

		if(_input[0].files[0]){

			$(this).addClass("filled");
			$(this).parent().find(".bt-close").addClass("filled");
			_label.text(_input[0].files[0].name);
			
			$(".add-file").removeClass("hidden");
			
			FilesManager.create_newFile(FilesManager.text, true);
			
		}else{
			// NO FILES
			$(this).removeClass("filled");
			$(this).parent().find(".bt-close").removeClass("filled");
			_label.text(noFile_text);
		}
	});

	$(".form-item." + _name + " .bt-close").on("click touchend", function(e){
		if(e.type=="touchend"){
			$(this).off("click");
		}
		
		/*Debug.log("REMOVE FILE : " + $(".files-manager .form-items.files .form-item").length);*/
		
		
		if(_input[0].files[0]){

			_input.val('');

			// NO FILES
			_input.removeClass("filled");
			_input.parent().find(".bt-close").removeClass("filled");
			_label.text(noFile_text);

			if((_isDynamic) || ($(".files-manager .form-items.files .form-item").length > 1)){
				FilesManager.removeFile(_name);
			}
		}
	});

}



$(window).load(function(){
	if($(".files-manager").length){
		FilesManager.init();
	}
});